import { FC } from 'react';

import { AdCampaignTypeEnum } from 'domain/media/types';

import { AD_TYPE_ART, INSTANT_AD_TYPE_ART } from './consts';
import styles from './index.module.scss';
import { TEXTS } from '../texts';
import { AdCampaignTypeHintProps } from './types';

const renderHintArt = (src: string) => (
  <div className={styles.infoArt}>
    <img
      src={src}
      alt=""
      loading="lazy"
      className={styles.infoArtImage}
    />
  </div>
);

const AdCampaignTypeHint: FC<AdCampaignTypeHintProps> = ({ campaignType }) => {
  switch (campaignType) {
    case AdCampaignTypeEnum.Interval:
      return (
        <>
          <p className={styles.infoText}>{TEXTS.INTERVAL_HINT_DESCRIPTION}</p>
          <ul className={styles.infoList}>
            {TEXTS.INTERVAL_HINT_STEPS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          {renderHintArt(AD_TYPE_ART[AdCampaignTypeEnum.Interval])}
        </>
      );

    case AdCampaignTypeEnum.ExactTime:
      return (
        <>
          <p className={styles.infoText}>{TEXTS.AD_TYPE_EXACT_EXPLANATION}</p>
          {renderHintArt(AD_TYPE_ART[AdCampaignTypeEnum.ExactTime])}
        </>
      );

    case AdCampaignTypeEnum.Period:
      return (
        <>
          <p className={styles.infoText}>{TEXTS.AD_TYPE_PERIOD_EXPLANATION}</p>
          {renderHintArt(AD_TYPE_ART[AdCampaignTypeEnum.Period])}
        </>
      );

    case AdCampaignTypeEnum.Instant:
      return (
        <>
          <p className={styles.infoText}>{TEXTS.AD_TYPE_INSTANT_EXPLANATION_TWO}</p>
          {renderHintArt(INSTANT_AD_TYPE_ART.campaign)}
          <p className={styles.infoText}>{TEXTS.INSTANT_LAUNCH_HINT}</p>
          {renderHintArt(INSTANT_AD_TYPE_ART.device)}
          <p className={styles.infoText}>{TEXTS.INSTANT_DEVICE_HINT}</p>
        </>
      );

    default:
      return null;
  }
};

export default AdCampaignTypeHint;
